import React, { useState } from "react";
import { Router, useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { showNumSix, reverseShowNums } from "./constants/constants";

const persianNumbers = [
  /۰/g,
  /۱/g,
  /۲/g,
  /۳/g,
  /۴/g,
  /۵/g,
  /۶/g,
  /۷/g,
  /۸/g,
  /۹/g,
];
const arabicNumbers = [
  /٠/g,
  /١/g,
  /٢/g,
  /٣/g,
  /٤/g,
  /٥/g,
  /٦/g,
  /٧/g,
  /٨/g,
  /٩/g,
];
export const fixNumbers = (str) => {
  if (typeof str === "string") {
    for (var i = 0; i < 10; i++) {
      str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
    }
  }
  return str;
};

export const MenuItem = ({ route, isActive, text }) => {
  const navigate = useNavigate();

  return (
    <li className="mb-3" onClick={() => navigate(route)}>
      <span className={isActive ? "sidebar-active-link" : "sidebar-link"}>
        {text}
      </span>
    </li>
  );
};

export const EmptyData = ({ text }) => {
  return (
    <>
      <div className="flex flex-col items-center mt-10">
        <ErrorOutlineIcon sx={{ fontSize: "4rem", color: "#adb5bd" }} />
        <p className="mt-4 text-slate-400 text-center text-sm md:text-base">
          {text}
        </p>
      </div>
    </>
  );
};

export const ageList = [
  {
    name: "زنانه",
    value: "woman",
  },
  {
    name: "بچگانه",
    value: "girl",
  },
];

export const colorList = [
  {
    name: "زرد",
    value: "yellow",
  },
  {
    name: "سفید",
    value: "white",
  },
];

export const messageReceiver = [
  {
    name: "مشتری",
    value: "customer",
  },
  {
    name: "تولید کننده",
    value: "provider",
  },
  {
    name: "تمامی مشتریان",
    value: "customers",
  },
  {
    name: "تمامی تولیدکنندگان",
    value: "providers",
  },
  {
    name: "تمامی اعضا",
    value: "all",
  },
];

export const translateGender = (name) => {
  switch (name) {
    case "woman":
      return "زنانه";

    case "girl":
      return "بچگانه";
    default:
      break;
  }
};

export const translateState = (name) => {
  switch (name) {
    case "onprogress":
      return "جاری";
    case "waiting":
      return "جدید";
    case "complete":
      return "تحویل داده شده";
    default:
      break;
  }
};

export const translateColor = (name) => {
  switch (name) {
    case "yellow":
      return "زرد";

    case "white":
      return "سفید";
    default:
      break;
  }
};

export const translateLog = (state) => {
  switch (state) {
    case "order_create":
      return "ایجاد سفارش";
    case "order_move_to_onprogress":
      return "انتقال به سفارش در حال اجرا";
    case "order_create_sub_factor":
      return "ایجاد زیرفاکتور";
    case "order_cancel":
      return "کنسل سفارش";
    case "order_change_customer":
      return "تغییر مشتری سفارش";
    case "order_change_state":
      return "تغییر وضعیت سفارش";
    case "order_add_item":
      return "اضافه کردن ایتم به سفارش";

    default:
      break;
  }
};

const ringHeadersList = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "النگو" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "created_at", name: "تاریخ ثبت‌سفارش" },
  { colName: "code_one", name: "تعداد یک" },
  { colName: "code_two", name: "تعداد دو" },
  { colName: "code_three", name: "تعداد سه" },
  { colName: "code_four", name: "تعداد چهار" },
  { colName: "code_five", name: "تعداد پنج" },
  { colName: "details", name: "جزییات" },
];
const ltrRingHeadersList = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "النگو" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "created_at", name: "تاریخ ثبت‌سفارش" },
  { colName: "code_five", name: "تعداد پنج" },

  { colName: "code_four", name: "تعداد چهار" },

  { colName: "code_three", name: "تعداد سه" },

  { colName: "code_two", name: "تعداد دو" },

  { colName: "code_one", name: "تعداد یک" },
  { colName: "details", name: "جزییات" },
];
const ringHeadersListWithNumSix = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "النگو" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "created_at", name: "تاریخ ثبت‌سفارش" },
  { colName: "code_one", name: "تعداد یک" },
  { colName: "code_two", name: "تعداد دو" },
  { colName: "code_three", name: "تعداد سه" },
  { colName: "code_four", name: "تعداد چهار" },
  { colName: "code_five", name: "تعداد پنج" },
  { colName: "code_six", name: "تعداد شش" },
  { colName: "details", name: "جزییات" },
];
const ltrRingHeadersListWithNumSix = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "النگو" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "created_at", name: "تاریخ ثبت‌سفارش" },
  { colName: "code_six", name: "تعداد شش" },

  { colName: "code_five", name: "تعداد پنج" },

  { colName: "code_four", name: "تعداد چهار" },

  { colName: "code_three", name: "تعداد سه" },

  { colName: "code_two", name: "تعداد دو" },

  { colName: "code_one", name: "تعداد یک" },
  { colName: "details", name: "جزییات" },
];
export const ringTableItems = () => {
  if (showNumSix) {
    if (reverseShowNums) {
      return ltrRingHeadersListWithNumSix;
    }
    return ringHeadersListWithNumSix;
  } else {
    if (reverseShowNums) {
      return ltrRingHeadersList;
    }
    return ringHeadersList;
  }
};

const ringDataKey = [
  "code",
  "show_name",
  "gender",
  "color",
  "created_at",
  "size_one_num",
  "size_two_num",
  "size_three_num",
  "size_four_num",
  "size_five_num",
];
const ringDataKeyWithNumSix = [
  "code",
  "show_name",
  "gender",
  "color",
  "created_at",
  "size_one_num",
  "size_two_num",
  "size_three_num",
  "size_four_num",
  "size_five_num",
  "size_six_num",
];
export const ringTableItemsDataKey = () => {
  if (showNumSix) {
    return ringDataKeyWithNumSix;
  } else return ringDataKey;
};

export const handleEnterKey = (event , func) => {
  if (event.keyCode === 13) {
    func();
}
}
